import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=2b1f8286&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=2b1f8286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f8286",
  null
  
)

export default component.exports